import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import { arrayOf, bool, func, object, string } from 'prop-types';
import AttributionTimespan from '../AttributionTimespan';
import TrafficChannels, { TRAFFIC_CHANNELS } from '../TrafficChannels';
import TimeZone, { TIME_ZONE } from '../TimeZone';
import { isEqual, get, isEmpty } from 'lodash';
import {
  DEFAULT_TIME_ZONE_KEY,
  DEFAULT_TIME_ZONE_NAME
} from '../TimeZoneSelector/constants';
import CampaignAnalyticsTopics, { CAMPAIGN_ANALYTICS_TOPICS } from '../CampaignAnalyticsTopics'
import styles from './styles.scss';
import classNames from 'classnames';
import { modules } from 'veritone-redux-common';
import LocationGranularity, { LOCATION_GRANULARITY, locationGranularityType } from '../LocationGranularity';
import CampaignSearchInstructions, { CAMPAIGN_SEARCH_INSTRUCTIONS, MAXIMUM_TEXT_LIMIT } from '../CampaignSearchInstructions';


const DATE_RANGES = 'date_ranges';
const { user: {
  selectUser
} } = modules;

export const locationAndChannelsOptions = [locationId, trafficChannelsId];

export class CampaignConfig extends Component {
  static propTypes = {
    className: string,
    saveBtnLabel: string,
    updateAppSettingSaga: func,
    appSetting: arrayOf(object),
    trafficChannels: arrayOf(object),
    getAppSettingSaga: func,
    campaignAnalyticsTopics: arrayOf(object),
    isDeviceCategoryAndPagePath: bool,
    locationGranularity: arrayOf(locationGranularityType),
    isGbqEnabled: bool,
    isAdobeEnabled: bool
  };

  static defaultProps = {
    saveBtnLabel: 'Save',
  }

  state = {
    prevAppSetting: [],
    [DATE_RANGES]: {
      setting_name: DATE_RANGES,
      setting_value: {
        isOverride: false,
        default: 8,
        ranges: []
      }
    },
    [TRAFFIC_CHANNELS]: {
      setting_name: TRAFFIC_CHANNELS,
      setting_value: {
        isOverride: false,
        selected: []
      }
    },
    [TIME_ZONE]: {
      setting_name: TIME_ZONE,
      setting_value: {
        name: DEFAULT_TIME_ZONE_NAME,
        timezoneKey: DEFAULT_TIME_ZONE_KEY,
        isOverride: false
      }
    },
    [CAMPAIGN_ANALYTICS_TOPICS]: {
      setting_name: CAMPAIGN_ANALYTICS_TOPICS,
      setting_value: []
    },
    [LOCATION_GRANULARITY]: {
      setting_name: LOCATION_GRANULARITY,
      setting_value: []
    },
    [CAMPAIGN_SEARCH_INSTRUCTIONS]: {
      setting_name: CAMPAIGN_SEARCH_INSTRUCTIONS,
      setting_value: [
        {
          search_instruction_name: "pre_recorded",
          value: ""
        },
        {
          search_instruction_name: "live_read",
          value: ""
        },
      ]
    },
    isSaveBtnDisabled: true
  };

  static getDerivedStateFromProps(props, state) {
    const { appSetting = [] } = props;
    const prevAppSetting = state.prevAppSetting;
    if (!isEqual(appSetting, prevAppSetting)) {
      const appSettingHashMap = appSetting.reduce((acc, setting) => {
        const { setting_name, setting_value } = setting;

        const isCampaignTopicsSetting = setting_name === CAMPAIGN_ANALYTICS_TOPICS;
        return {
          ...acc,
          [setting_name]: {
            setting_name,
            setting_value: isCampaignTopicsSetting
              ? setting_value
              : {
                  ...setting_value
                }
          }
        };
      }, {});
      return ({
        prevAppSetting: appSetting,
        [DATE_RANGES]: appSettingHashMap[DATE_RANGES],
        [TRAFFIC_CHANNELS]: appSettingHashMap[TRAFFIC_CHANNELS],
        [TIME_ZONE]: appSettingHashMap[TIME_ZONE],
        [CAMPAIGN_ANALYTICS_TOPICS]: appSettingHashMap[CAMPAIGN_ANALYTICS_TOPICS],
        [LOCATION_GRANULARITY]: appSettingHashMap[LOCATION_GRANULARITY],
        [CAMPAIGN_SEARCH_INSTRUCTIONS]: appSettingHashMap[CAMPAIGN_SEARCH_INSTRUCTIONS],
      })
    }
    return state;
  }


  componentDidUpdate = (prevProps, prevState) => {

    if (!isEqual(this.state, prevState)) {
      const campaignSearchInstruction = get(this.state, [CAMPAIGN_SEARCH_INSTRUCTIONS, 'setting_value' ], []);
      //Check value for campaignSearchInstruction is more than 600 character excluding spaces
      const isMaximumTextLimit = Object.values(campaignSearchInstruction).some(
        item => {
          const value = get(item, 'value', '');
          const formatValue = String(value).split(" ").join("");

          return formatValue.length > MAXIMUM_TEXT_LIMIT
        }
      );
      this.setState({ isSaveBtnDisabled: isMaximumTextLimit });

    }
  }

  componentDidMount() {
    const { getAppSettingSaga, appSetting } = this.props;
    if (isEmpty(appSetting)) {
      getAppSettingSaga && getAppSettingSaga();
    }
  }

  updateAppSetting = input => {
    const { setting_name, setting_value } = input;

    this.setState(prevState => {
      let settingValue;
      switch (setting_name) {
        case CAMPAIGN_ANALYTICS_TOPICS:
        case LOCATION_GRANULARITY:
        case CAMPAIGN_SEARCH_INSTRUCTIONS:  {
          settingValue = setting_value;
          break;
        }
        default:
          settingValue = {
            ...prevState[setting_name].setting_value,
            ...setting_value
          };
      }
      return {
        [setting_name]: {
          setting_name,
          setting_value: settingValue
        },
        isSaveBtnDisabled: false
      };
    });
  }

  handleSaveClick = () => {
    const { updateAppSettingSaga, appSetting } = this.props;
    const date_ranges = this.state[DATE_RANGES];
    const traffic_filter = this.state[TRAFFIC_CHANNELS];
    const time_zone = this.state[TIME_ZONE];
    const location_granularity = this.state[LOCATION_GRANULARITY];
    const campaign_analytics_topics = this.state[CAMPAIGN_ANALYTICS_TOPICS];
    const campaign_search_instruction = this.state[CAMPAIGN_SEARCH_INSTRUCTIONS];

    const newAppSetting =  appSetting.map(setting => {
      let newSetting = {...setting};
      switch(setting.setting_name) {
        case DATE_RANGES: {
          newSetting = {...newSetting, ...date_ranges};
          break;
        }
        case TRAFFIC_CHANNELS: {
          newSetting = {...newSetting, ...traffic_filter};
          break;
        }
        case TIME_ZONE: {
          newSetting = {...newSetting, ...time_zone};
          break;
        }
        case CAMPAIGN_ANALYTICS_TOPICS: {
          newSetting = {...newSetting, ...campaign_analytics_topics};
          break;
        }
        case LOCATION_GRANULARITY: {
          newSetting = {...newSetting, ...location_granularity};
          break;
        }
        case CAMPAIGN_SEARCH_INSTRUCTIONS: {
          newSetting = {...newSetting, ...campaign_search_instruction};
          break;
        }
      }
      return newSetting;
    })

    updateAppSettingSaga && updateAppSettingSaga(newAppSetting);
    this.setState({ isSaveBtnDisabled: true });
  };

  handleDisableSave = () => {
    this.setState({ isSaveBtnDisabled: true });
  }

  render() {
    const {
      className,
      saveBtnLabel,
      trafficChannels,
      isDeviceCategoryAndPagePath,
      locationGranularity,
      isGbqEnabled,
      isAdobeEnabled
    } = this.props;

    const { isSaveBtnDisabled } = this.state;

    const { isOverride: isOverrideTrafficChannel, selected } = get(this.state, [TRAFFIC_CHANNELS, 'setting_value' ], {});
    const campaignAnalyticsTopics = get(this.state, [CAMPAIGN_ANALYTICS_TOPICS, 'setting_value' ], []);
    const campaignSearchInstruction = get(this.state, [CAMPAIGN_SEARCH_INSTRUCTIONS, 'setting_value' ], []);
    const { isOverride: isOverrideTimeZone, name, timezoneKey  } = get(this.state, [TIME_ZONE, 'setting_value'], {});
    const date_ranges = get(this.state, [DATE_RANGES, 'setting_value' ], {});
    const selectedTimeZone = { name, timezoneKey };
    const selectedLocationId = get(this.state, [LOCATION_GRANULARITY, 'setting_value', '0' ], '');
    return (
      <div className={classNames(className, styles.attributionTimespan)}>
        <TimeZone
          onChange={this.updateAppSetting}
          isOverrideable={isOverrideTimeZone}
          selectedTimeZone={selectedTimeZone}
        />
        <AttributionTimespan
          updateAppSetting={this.updateAppSetting}
          appSetting={date_ranges}
        />
        <TrafficChannels
          isOverrideable={isOverrideTrafficChannel}
          onChange={this.updateAppSetting}
          trafficChannels={trafficChannels}
          isGbqEnabled={isGbqEnabled}
          selected={selected}
          isAdobeEnabled={isAdobeEnabled}
          isInConfig
        />
        <CampaignAnalyticsTopics
          onChange={this.updateAppSetting}
          data={campaignAnalyticsTopics}
          disabledListItem={locationAndChannelsOptions}
          isDeviceCategoryAndPagePath={isDeviceCategoryAndPagePath}
        />
        <LocationGranularity
          data={locationGranularity}
          selectedLocationGranularityId={selectedLocationId}
          onChange={this.updateAppSetting}
         />
        <CampaignSearchInstructions
          data={campaignSearchInstruction}
          onChange={this.updateAppSetting}
          handleDisableSave={this.handleDisableSave}
        />
        <div className={styles.saveButton}>
          <Button
            color="primary"
            variant="contained"
            disabled={isSaveBtnDisabled}
            onClick={this.handleSaveClick}
          >
            {saveBtnLabel}
          </Button>
        </div>
      </div>
    );
  }
}

import { connect } from 'react-redux';
import { compose } from 'redux';
import { getAppSettingSaga, updateAppSettingSaga } from '../../state/modules/app/appSetting';
import { namespace as trafficChannelNameSpace} from '../../state/modules/app/trafficChannel/actions';
import { namespace as locationGranularityNameSpace } from '../../state/modules/app/locationGranularity/actions';
import { locationId, trafficChannelsId } from '../../pages/ReportBuilder/constants';
import { checkEnableFeatureFlag, getEnabledFlagsInConfigApp } from '../../helpers/common';
import { ADOBE_ANALYTICS_FEATURE_FLAG_KEY } from '../../helpers/constant';
import Advertiser from '../../pages/Advertiser';

export default connect(
  (state, props) => {
    const attributionConfig = get(
      selectUser(state),
      'organization.kvp.features.attribute',
      {}
    );
    const enabledFlagsConfigApp = getEnabledFlagsInConfigApp(props, state);
    const isEnabledAdobeConnectionType = checkEnableFeatureFlag(enabledFlagsConfigApp, [ADOBE_ANALYTICS_FEATURE_FLAG_KEY]);
    return {
      appSetting: state.appSetting.data,
      trafficChannels: get(state, [trafficChannelNameSpace, 'data'], []),
      isDeviceCategoryAndPagePath:
        get(attributionConfig, 'deviceCategoryAndPagePath') === 'enabled',
      locationGranularity:  get(state, [locationGranularityNameSpace, 'data'], []),
      isGbqEnabled: 
        get(attributionConfig, 'googleBigQueryIngestion') === 'enabled',
      isAdobeEnabled : isEnabledAdobeConnectionType
        
    };
  },
  dispatch => ({
    getAppSettingSaga: compose(dispatch, getAppSettingSaga),
    updateAppSettingSaga: compose(dispatch, updateAppSettingSaga)
  })
)(CampaignConfig);
